import React from "react";
import "./FeaturesSection.css";
import herbsImg from "../assets/ancient_herbs.png";
import sectionLabel from "../assets/icons/section_label.svg";

function FeaturesSection() {
  return (
    <section className="features-section">
      <div className="features-container">
        <div className="features-image-wrap">
          <img src={herbsImg} alt="Chinese herbal medicine books and herbs" />
        </div>
        <div className="features-content">
          <div className="features-section-label flex-center">
            <img src={sectionLabel} alt="" width="192" height="32" />
          </div>
          <h2 className="features-title">
            Ancient wisdom. Personalized for modern life.
          </h2>
          <div className="features-body">
            <p>
              Each Hua Shen formula is carefully selected and customized after a
              detailed intake reviewed by a licensed practitioner trained in
              Traditional Chinese Medicine.
            </p>
            <p>
              Your herbs are chosen with intention to support your unique
              symptoms, constitution, and long-term health goals.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FeaturesSection;
